import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface GameUserStatus {
  status: boolean
  isExist: boolean | undefined
}

interface GameState {
  balance: number
  userStatus: GameUserStatus
  ipBan: boolean
}

const initialState: GameState = {
  balance: 0,
  userStatus: {
    status: true,
    isExist: undefined,
  },
  ipBan: false,
}

const slice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    updateGameBalance(state, action: PayloadAction<number>) {
      state.balance = action.payload
    },
    updateGameUserStatus(state, action: PayloadAction<GameUserStatus>) {
      state.userStatus = action.payload
      // 如果狀態可以取得，自動解除ip ban
      state.ipBan = false
    },
    updateGameIpBan(state, action: PayloadAction<boolean>) {
      state.ipBan = action.payload
    },
  },
})

export const { actions } = slice
export default slice.reducer
